import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
/**
 * useDetailParam
 *
 * A custom hook that returns the current "detail" parameter from the URL.
 */
export var useDetailParam = function () {
    var location = useLocation();
    var history = useHistory();
    var _a = useState(null), detailId = _a[0], setDetailId = _a[1];
    // Stable identity: consumers list it in effect dependencies.
    var updateDetailParam = useCallback(function (detail) {
        var queryParams = new URLSearchParams(history.location.search);
        if (detail) {
            queryParams.set("detail", detail);
            setDetailId(detail);
        }
        else {
            queryParams.delete("detail");
            setDetailId(null);
        }
        history.push({ search: queryParams.toString() });
    }, [history]);
    useEffect(function () {
        var queryParams = new URLSearchParams(location.search);
        setDetailId(queryParams.get("detail"));
    }, [location.search]);
    return { detailId: detailId, updateDetailParam: updateDetailParam };
};
